/**
 * PostHog analytics helper. Safe to call when PostHog is not loaded (e.g. POSTHOG_API_KEY unset).
 * Use capture() for events and identify() when the user signs in.
 */

/**
 * Capture a custom event. No-op if PostHog is not loaded.
 * @param {string} eventName - e.g. 'search_performed', 'signed_in'
 * @param {Record<string, unknown>} [properties] - optional event properties
 */
export function capture(eventName, properties = {}) {
    if (typeof window !== 'undefined' && window.posthog) {
        try {
            window.posthog.capture(eventName, properties);
        } catch (e) {
            console.warn('[PostHog] capture failed:', e);
        }
    }
}

/**
 * Identify the current user (call after sign-in). No-op if PostHog is not loaded.
 * @param {string} distinctId - stable user id (e.g. user_id from backend)
 * @param {Record<string, unknown>} [personProperties] - e.g. { email, name }
 */
export function identify(distinctId, personProperties = {}) {
    if (typeof window !== 'undefined' && window.posthog) {
        try {
            window.posthog.identify(distinctId, personProperties);
        } catch (e) {
            console.warn('[PostHog] identify failed:', e);
        }
    }
}

/**
 * Reset PostHog state (call on sign-out so next user is not tied to previous).
 * No-op if PostHog is not loaded.
 */
export function reset() {
    if (typeof window !== 'undefined' && window.posthog) {
        try {
            window.posthog.reset();
        } catch (e) {
            console.warn('[PostHog] reset failed:', e);
        }
    }
}
